import React, { useState } from "react";
import { motion } from "framer-motion/dist/framer-motion";
import { staticBounceVariants } from "shared/components/animations";
const DWQuestionCard = ({ askedQuestion, is_big_question_card = false }) => {
  const AskedQuestion = askedQuestion?.replace(/\[BLANK\]/g, "_______");

  return (
    <motion.div
      variants={staticBounceVariants}
      className={`question-card ${
        is_big_question_card ? "" : "question-card-small"
      }`}
    >
      <h4 className="question">{AskedQuestion}</h4>
      {is_big_question_card && <p className="hashtag">#DoneWith2020</p>}
    </motion.div>
  );
};

export default DWQuestionCard;
